import { render, staticRenderFns } from "./uf_is_reestr_using_rm.vue?vue&type=template&id=329aaa66&scoped=true"
import script from "./uf_is_reestr_using_rm.vue?vue&type=script&lang=js"
export * from "./uf_is_reestr_using_rm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329aaa66",
  null
  
)

export default component.exports